import { useTranslation } from 'react-i18next'

type ActivityStreamIndicatorProps = {
  connected: boolean
}

/**
 * Live/Offline-Pill neben dem Seitentitel (Prototyp: `● live`-Pill in der
 * Subline, activities.html:24). Ersetzt den frueheren freischwebenden Punkt
 * am Seitenende — Position + Optik jetzt pixelgenau am Prototyp, Funktion
 * (SSE-Verbindungsstatus aus useActivityStream) unveraendert.
 */
export function ActivityStreamIndicator({ connected }: ActivityStreamIndicatorProps) {
  const { t } = useTranslation('activity')
  return (
    <span
      className={`pill ${connected ? 'pill-success' : 'pill-muted'}`}
      style={{ fontSize: '10px', gap: '4px' }}
      title={connected ? t('stream.connected') : t('stream.offline')}
      role="status"
      aria-live="polite"
    >
      <span className="dot" />
      {connected ? t('stream.liveLabel') : t('stream.offlineLabel')}
    </span>
  )
}
